import React from 'react';
import { Container } from 'react-bootstrap';
import ClHeader from 'components/clientComp/clHeader';
import { ClDrawerLeft } from 'components/clientComp/clDrawer';
import { useNavigate } from 'react-router-dom';
import { useDynamicTitle } from 'shared/helpers';

import './ClPageNotFound.scss';

const ClPageNotFound = () => {
  useDynamicTitle('Page Not Found');
  const navigate = useNavigate();
  return (
    <Container fluid className="cl-pnf">
      <ClHeader />
      <div className="cl-pnf-container cl-homepage-container">
        <div className="cl-homepage-left__side">
          <ClDrawerLeft />
        </div>
        <Container className="cl-homepage-main cl-pnf-main d-flex flex-column justify-content-center align-items-center">
          <h6
            data-aos="fade-down"
            data-aos-duration="1000"
            className="cl-pnf-title"
          >
            404
          </h6>
          <p
            data-aos="fade-up"
            data-aos-duration="1000"
            className="cl-pnf-subtitle"
          >
            Page not found
          </p>
          <button
            data-aos="zoom-in"
            data-aos-duration="1000"
            onClick={() => navigate('/')}
            className="download-resume"
          >
            Go back home
          </button>
        </Container>
        <div className="cl-homepage-right__side">
          <ClDrawerLeft />
        </div>
      </div>
    </Container>
  );
};

export default ClPageNotFound;
